// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "./assets/build/main." + {"451":"cd0460311ff1208dec55","490":"cd0460311ff1208dec55","717":"cd0460311ff1208dec55","754":"cd0460311ff1208dec55","790":"cd0460311ff1208dec55"}[chunkId] + ".min.css";
};